import React from 'react'
import { Select, useToast } from '@chakra-ui/react'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import StudentsService from '../../API/StudentsService'
import { useStudentsStore } from '../../store/studentsStore'
import { toastSuccess, toastError } from '../../utils/globalHelper'
import { useProlongationsStore } from '../../store/prolongationsStore'
import { useScoreStore } from '../../store/scoreStore'

function SelectCommunicationType({student}) {
    const toast = useToast()
    const studentSiteId = student?.site_id || student?.student_id
    const [communicationTypes, updateStudentCommType] = useStudentsStore(state => [state.communicationTypes, state.updateStudentCommType])
    const updatePurchaseCommType = useProlongationsStore(state => state.updatePurchaseCommType)
    const updateScoreCommType = useScoreStore(state => state.updateCommType)
    const updateCommunicationType = useAccessAPI(StudentsService.updateCommunicationType)

    const onCommunicationTypeChange = async (event) => {
        const type_id = Number(event.target.value) === 0 ? null : Number(event.target.value)
        const response = await updateCommunicationType(studentSiteId, type_id)
        if (response?.status === 200) {
            if (type_id) {
                const type = response.data.communication_type
                updatePurchaseCommType(studentSiteId, type)
                updateStudentCommType(studentSiteId, type)
                updateScoreCommType(studentSiteId, type)
                toast(toastSuccess('Тип связи обновлен'))
            }
        } 
        else {
            toast(toastError('Не удалось обновить тип связи'))
        }
    }

    return (
        <Select
            placeholder='-'
            value={student?.communication_type?.id || ''}
            onChange={onCommunicationTypeChange}
        >
            {communicationTypes.map((type) => (
                <option value={type.id} key={`commType${type.id}`}>
                    {type.title}
                </option>
            ))}
        </Select>
    )
}

export default SelectCommunicationType
